"use strict";

var _slicedToArray = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = void 0;

var tslib_1 = require("tslib");

var react_1 = (0, tslib_1.__importStar)(require("react"));

var utils_1 = require("./utils");

function obfuscateEmail(email) {
  var _email$split = email.split("@"),
      _email$split2 = _slicedToArray(_email$split, 2),
      username = _email$split2[0],
      domain = _email$split2[1];

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n          a>span.roe::after {\n            content: \"@\";\n          }\n        "
    }
  }), username, react_1.default.createElement("span", {
    className: "roe"
  }), domain);
}

function Email(_a) {
  var _a$bcc = _a.bcc,
      bcc = _a$bcc === void 0 ? [] : _a$bcc,
      _a$body = _a.body,
      body = _a$body === void 0 ? "" : _a$body,
      _a$cc = _a.cc,
      cc = _a$cc === void 0 ? [] : _a$cc,
      children = _a.children,
      email = _a.email,
      _a$subject = _a.subject,
      subject = _a$subject === void 0 ? "" : _a$subject,
      props = (0, tslib_1.__rest)(_a, ["bcc", "body", "cc", "children", "email", "subject"]);

  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      hovered = _ref2[0],
      setHovered = _ref2[1];

  var emailUrl = new URL("mailto:".concat(email));
  emailUrl.search = (0, utils_1.percentEncodeParams)({
    bcc: bcc,
    body: body,
    cc: cc,
    subject: subject
  });

  function handleHover() {
    setHovered(true);
  }

  var displayText = children || email;
  var obfuscatedText = children || obfuscateEmail(email);
  return react_1.default.createElement("a", Object.assign({
    href: hovered ? emailUrl.href : "#",
    onFocus: handleHover,
    onMouseOver: handleHover
  }, props), hovered ? displayText : obfuscatedText);
}

exports.Email = Email;